import {FunctionComponent} from "react";
import {ChangeFormTemplate} from "./changeFormTemplate";
import {ChangeSubscriptionForm} from "../organisms/forms/changeSubscriptionForm";

interface ChangeSubscriptionTemplateProps {
  update: boolean;
  handleSubmit: (email: string) => Promise<void>;
}

export const ChangeSubscriptionTemplate: FunctionComponent<ChangeSubscriptionTemplateProps> = ({update, handleSubmit}) => (
    <ChangeFormTemplate disableMinHeight={true} loading={update}>
        <ChangeSubscriptionForm handleSubmit={handleSubmit}/>
    </ChangeFormTemplate>
)